import { ConditionalTransformation, DirectTransformation } from './Transformations';

export class WideAdjustToOneToOneTransformation extends DirectTransformation {
  constructor() {
    super('c_lfill', 'g_xy_center', 'h_700', 'w_700', 'x_800', 'y_200');
  }
}

export class SideFourToThreeAdjustToOneToOneTransformation extends DirectTransformation {
  constructor() {
    super('c_crop', 'g_center', 'ar_1');
  }
}

export class AdjustQualityTransformation extends DirectTransformation {
  constructor() {
    super('f_auto', 'q_auto:best', 'dpr_auto');
  }
}

export class ScaleTransformation extends DirectTransformation {
  constructor(side: number) {
    super('c_scale', `w_${side}`);
  }
}

export class ThumbnailPdpHeroTransformation extends DirectTransformation {
  constructor() {
    super('c_scale', 't_pdpHeroGallery_Thumbnail');
  }
}

export class GalleryPdpHeroTransformation extends DirectTransformation {
  constructor() {
    super('c_scale', 't_pdpHeroGallery_Gallery');
  }
}

export class ZoomPdpHeroTransformation extends DirectTransformation {
  constructor() {
    super('c_scale', 't_pdpHeroGallery_Zoom');
  }
}

export class IsWideConditional extends ConditionalTransformation {
  constructor() {
    super('ar_gt_2');
  }
}

export class IsFourToThreeConditional extends ConditionalTransformation {
  constructor() {
    super('ar_gt_1.1', 'ar_lt_1.9');
  }
}

export class IsNotOneToOneConditional extends ConditionalTransformation {
  constructor() {
    super('ar_gt_1.1');
  }
}
